import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="60"
    height="46"
    viewBox="0 0 60 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.8252 19.2864C54.4919 20.826 54.4919 24.675 51.8252 26.2146L32.6995 37.2568C30.0328 38.7964 26.6995 36.8719 26.6995 33.7927L26.6995 11.7082C26.6995 8.62903 30.0328 6.70453 32.6995 8.24414L51.8252 19.2864Z"
      stroke="#81BC00"
      strokeWidth="2"
    />
    <path
      d="M37.501 19.2864C40.1676 20.826 40.1676 24.675 37.501 26.2146L18.3753 37.2568C15.7086 38.7964 12.3753 36.8719 12.3753 33.7927L12.3753 11.7082C12.3753 8.62903 15.7086 6.70453 18.3753 8.24414L37.501 19.2864Z"
      stroke="#81BC00"
      strokeWidth="2"
    />
  </svg>,
  "ArrowNextIcon"
);
